<style>

  div {
    border-radius: 5px;
  }
  form {
    
    width: 80%;
    margin: auto;
    text-align: center;
  }
  .form-group {
    margin-bottom: 1rem;
    text-align: left;
}
 input,
select {
  width: 203px;          /* match parent container */
  max-width: 203px;     /* optional, same as desktop input max */
  background-color: #EBEBEB !important;
  border: 1px solid #4F4D4A;
  border-radius: 6px;
  box-sizing: border-box; /* ensures padding/border included in width */
}

/* Optional: placeholder styling */
input::placeholder {
  color: #666;
}

/* For mobile view */
@media (max-width: 768px) {
  input,
  select {
    width: 100%;         /* full width of container on mobile */
    max-width: 100%;     /* override desktop max-width */
  }
}

select option {
  background-color: white;
}
  button:disabled {
    background-color: grey;
  }
  </style>

<!--  ----------------------------------------------------------------------  -->
<!--  NOTE: Please add the following <META> element to your page <HEAD>.      -->
<!--  If necessary, please modify the charset parameter to specify the        -->
<!--  character set of your HTML page.                                        -->
<!--  ----------------------------------------------------------------------  -->
<div class="mercedes-me-login__column_left">
  <h2 class="mercedes-me-login__column_left-headline" style="color: black; font-family: 'corporateSDemiRegular';">Request More Information</h2>
</div>

<META HTTP-EQUIV="Content-type" CONTENT="text/html; charset=UTF-8">


<div *ngIf="this.env==='stage'"> 
  <!--  ----------------------------------------------------------------------  -->
  <!--  NOTE: Please add the following <FORM> element to your page.             -->
  <!--  ----------------------------------------------------------------------  -->
  
  <form ngNoForm action="https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DWC000008d9tF" method="POST" (ngSubmit)="onFormSubmit()">
  
    <input type=hidden name="oid" value="00DWC000008d9tF">
    <input type=hidden name="retURL" value="{{this.baseRedirect}}/home/ConnectedInsurancethankyou">    
  
<div class="shortrow" >
    <div class="form-group">
      <input  type="text" class="form-control" required validateonblur value=""
      placeholder= "First Name*" id="first_name" maxlength="40" name="first_name"  ngModel  #firstname="ngModel">
    </div>

    <div class="form-group">
      <input type="text" class="form-control"  required validateonblur value=""
      placeholder= "Last Name*" id="last_name" maxlength="80" name="last_name"  ngModel  #lastname="ngModel">
    </div>
</div>
<div class="shortrow">
  <div class="form-group">
  <input class="form-control" type="number" min="10" formControlName="phone" [(ngModel)]="phone" required validateonblur value=""  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (input)="inputValidator($event)" maxlength="10" placeholder= "Phone Number*" id="phone" name="phone" >
  </div>
  <div class="form-group">
    <input class="form-control" type="email"   name="email" placeholder="Email Address*"  ngModel  #emailWithPattern="ngModel"   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"  maxlength="80" required  >
  </div> 
</div>
<div class="shortrow">
  <div class="form-group">
 <input type="text" class="form-control" required validateonblur value="" placeholder="Business Name*" id="company" maxlength="255"
  name="company" ngModel #company="ngModel">  </div>
  <div class="form-group">
    <select class="form-control" required value="" id="00NWC000005qHEn" name="00NWC000005qHEn" >
      <option value="" disabled selected>Fleet Size*</option>
      <option *ngFor="let fleetsize of fleetSizes" [value]="fleetsize">
        {{ fleetsize }}
      </option>
    </select>
  </div>
</div>
<div class="shortrow">
    <div class="form-group">
    <select class="form-control" name="state" required [(ngModel)]="selectedState" (change)="getCounties()"
      [disabled]="isStateDisabled" id="state" name="state">
      <option value="" disabled selected>State*</option>
      <option *ngFor="let state of states" [value]="state">
        {{ state }}
      </option>
    </select>
  </div>
    <div class="form-group">
      <select class="form-control" name="county" required [(ngModel)]="selectedCounty" [disabled]="isCountyDisabled" id="00N8W00000PYJyH" name="00N8W00000PYJyH">
        <option value="" disabled selected>County*</option>
        <option *ngFor="let county of counties" [value]="county">
          {{ county }}
        </option>
      </select>
  </div>
</div>


  <!-- <label for="recordType">Lead Record Type</label> -->
  <select  id="recordType" name="recordType" hidden>
    <option value="">--None--</option>
    <option value="0124R0000014p1d" selected="selected">Insurance</option>
    <option value="0121I000000Jso2" >DTNA Orderboard Leads</option>
    <option value="0121I000000JtAG">DTNA Program Lead</option>
    <option value="0128W000000epvI">Dynamic Insurance Lead</option>
    <option value="0121I000000JtAL">FMV</option>
    <option value="0121I000000Jso7">Other</option>
    </select>

    <!-- <label for="lead_source">Lead Source</label> -->
    <select  id="lead_source" name="lead_source" hidden>
      <option value="">--None--</option>
      <option value="Dealer">Dealer</option>
      <option value="HDVI">HDVI</option>
      <option value="DTNA_Orderboard">DTNA_Orderboard</option>
      <option value="Other">Other</option>
      <option value="Dynamic Lease">Dynamic Lease</option>
      <option value="DTNA Program">DTNA Program</option>
      <option value="DTNA/DTR FMV">DTNA/DTR FMV</option>
      <option value="Dynamic Insurance Lead">Dynamic Insurance Lead</option>
      <option value="Website - Dynamic Lease">Website - Dynamic Lease</option>
      <option value="Website - Connected Insurance" selected="selected">Website - Connected Insurance</option>
      <option value="Website - Dynamic Insurance">Website - Dynamic Insurance</option>
      <option value="Email">Email</option>
    </select>

      <select id="Country_Code__c" name="Country_Code__c" hidden>
        <option value="US" selected="selected">US</option>
      </select>

    <select  id="00N1I00000OUe8n" name="Lead_Type__c" hidden>
      <option value="Insurance" selected="selected">Insurance</option>
    </select>

    <select  id="DTFS_Language__c" name="DTFS_Language__c" hidden>
      <option value="EN" selected="selected">EN</option>
    </select>

  <!-- <input type="hidden" class="form-check-input" required id="00N0q000005yvHz" name="00N0q000005yvHz" value="0">Dynamic Insurance Flag -->

    <div class="form-check" style="padding-left: 0px;">
      <label class="checkboxlabel" for="checkbox" style="text-align: justify;">
        <p> By clicking submit, I agree that Daimler Truck Financial Services, Daimler Truck Insurance Agency, and GEICO may
      contact me with marketing communications related to Connected Insurance. I understand that my information will be used
      in accordance with the <a href="{{this.usUrl}}/home/useAndPrivacy">Daimler Truck Privacy Policy</a> and the <a
        href="https://www.geico.com/privacy/">GEICO Privacy Policy</a>.</p>
      </label>
    </div>


    <!--Error Display to Modal View-->
    <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
      <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
    </div>
    <div class="captcha" *ngIf="this.captchaToggle">
      <div id="capcha_element" class="g-recaptcha" data-theme="light"
          style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
          data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
        </div>
    </div>
    
    <button type="submit" name="submit" class="mbfs-button">Submit</button>
    <p style="float: right;" class="checkboxlabel"><span style="color: #00566A;">* </span>required</p> <br>
    <br><br>
  </form>
</div>

<div *ngIf="this.env==='prod'"> 
  <!--  ----------------------------------------------------------------------  -->
  <!--  NOTE: Please add the following <FORM> element to your page.             -->
  <!--  ----------------------------------------------------------------------  -->
  
  <form ngNoForm action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
  
  <input type=hidden name="oid" value="00D1I000001XfK4">
  <input type=hidden name="retURL" value="{{this.baseRedirect}}/home/ConnectedInsurancethankyou">
     
  
<div class="shortrow" >
    <div class="form-group">
      <input  type="text" class="form-control" required validateonblur value=""
      placeholder= "First Name*" id="first_name" maxlength="40" name="first_name"  ngModel  #firstname="ngModel">
    </div>

    <div class="form-group">
      <input type="text" class="form-control"  required validateonblur value=""
      placeholder= "Last Name*" id="last_name" maxlength="80" name="last_name"  ngModel  #lastname="ngModel">
    </div>
</div>
<div class="shortrow">
  <div class="form-group">
  <input class="form-control" type="number" min="10" formControlName="phone" [(ngModel)]="phone" required validateonblur value=""  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" (input)="inputValidator($event)" maxlength="10" placeholder= "Phone Number*" id="phone" name="phone" >
  </div>
  <div class="form-group">
    <input class="form-control" type="email"   name="email" placeholder="Email Address*"  ngModel  #emailWithPattern="ngModel"   pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$"  maxlength="80" required  >
  </div> 
</div>
<div class="shortrow">
  <div class="form-group">
 <input type="text" class="form-control" required validateonblur value="" placeholder="Business Name*" id="company" maxlength="255"
  name="company" ngModel #company="ngModel">  </div>
  <div class="form-group">
    <select class="form-control" required value="" id="00NVs00000YJzmf" name="00NVs00000YJzmf" >
      <option value="" disabled selected>Fleet Size*</option>
      <option *ngFor="let fleetsize of fleetSizes" [value]="fleetsize">
        {{ fleetsize }}
      </option>
    </select>
  </div>
</div>
<div class="shortrow">
    <div class="form-group">
    <select class="form-control" name="state" required [(ngModel)]="selectedState" (change)="getCounties()"
      [disabled]="isStateDisabled" id="state" name="state">
      <option value="" disabled selected>State*</option>
      <option *ngFor="let state of states" [value]="state">
        {{ state }}
      </option>
    </select>
  </div>
    <div class="form-group">
      <select class="form-control" name="county" required [(ngModel)]="selectedCounty" [disabled]="isCountyDisabled" id="00N8W00000PYJyH" name="00N8W00000PYJyH">
        <option value="" disabled selected>County*</option>
        <option *ngFor="let county of counties" [value]="county">
          {{ county }}
        </option>
      </select>
  </div>
</div>


  <!-- <label for="recordType">Lead Record Type</label> -->
  <select  id="recordType" name="recordType" hidden>
    <option value="">--None--</option>
    <option value="0124R0000014p1dQAA" selected="selected">Insurance</option>
    <option value="0121I000000Jso2" >DTNA Orderboard Leads</option>
    <option value="0121I000000JtAG">DTNA Program Lead</option>
    <option value="0128W000000epvI">Dynamic Insurance Lead</option>
    <option value="0121I000000JtAL">FMV</option>
    <option value="0121I000000Jso7">Other</option>
    </select>

    <!-- <label for="lead_source">Lead Source</label> -->
    <select  id="lead_source" name="lead_source" hidden>
      <option value="">--None--</option>
      <option value="Dealer">Dealer</option>
      <option value="HDVI">HDVI</option>
      <option value="DTNA_Orderboard">DTNA_Orderboard</option>
      <option value="Other">Other</option>
      <option value="Dynamic Lease">Dynamic Lease</option>
      <option value="DTNA Program">DTNA Program</option>
      <option value="DTNA/DTR FMV">DTNA/DTR FMV</option>
      <option value="Dynamic Insurance Lead">Dynamic Insurance Lead</option>
      <option value="Website - Dynamic Lease">Website - Dynamic Lease</option>
      <option value="Website - Connected Insurance" selected="selected">Website - Connected Insurance</option>
      <option value="Website - Dynamic Insurance">Website - Dynamic Insurance</option>
      <option value="Email">Email</option>
    </select>

      <select id="Country_Code__c" name="Country_Code__c" hidden>
        <option value="US" selected="selected">US</option>
      </select>

    <select  id="00N1I00000OUe8n" name="Lead_Type__c" hidden>
      <option value="Insurance" selected="selected">Insurance</option>
    </select>

    <select  id="DTFS_Language__c" name="DTFS_Language__c" hidden>
      <option value="EN" selected="selected">EN</option>
    </select>

  <!-- <input type="hidden" class="form-check-input" required id="00N0q000005yvHz" name="00N0q000005yvHz" value="0">Dynamic Insurance Flag -->

    <div class="form-check" style="padding-left: 0px;">
      <label class="checkboxlabel" for="checkbox" style="text-align: justify;">
        <p> By clicking submit, I agree that Daimler Truck Financial Services, Daimler Truck Insurance Agency, and GEICO may
      contact me with marketing communications related to Connected Insurance. I understand that my information will be used
      in accordance with the <a href="{{this.usUrl}}/home/useAndPrivacy">Daimler Truck Privacy Policy</a> and the <a
        target="_blank" href="https://www.geico.com/privacy/">GEICO Privacy Policy</a>.</p>
      </label>
    </div>


    <!--Error Display to Modal View-->
    <div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
      <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
    </div>
    <div class="captcha" *ngIf="this.captchaToggle">
      <div id="capcha_element" class="g-recaptcha" data-theme="light"
          style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;" data-callback="getResponceCapcha"
          data-expired-callback="recaptchaResponseExpired" data-error-callback="recaptchaError">
        </div>
    </div>
    
    <button type="submit" name="submit" class="mbfs-button">Submit</button>
    <p style="float: right;" class="checkboxlabel"><span style="color: #00566A;">* </span>required</p> <br>
    <br><br>
  </form>
</div>

<div *ngIf="this.env==='local'"> 
  <!--  ----------------------------------------------------------------------  -->
  <!--  NOTE: Please add the following <FORM> element to your page.             -->
  <!--  ----------------------------------------------------------------------  -->
  
  <form ngNoForm action="https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D3I0000000zcL" method="POST">
  
  <input type=hidden name="oid" value="00D3I0000000zcL">
  <input type=hidden name="retURL" value="{{this.baseRedirect}}/home/ConnectedInsurancethankyou">
  
  
<div class="shortrow">
  <div class="form-group">
    <input type="text" class="form-control" required validateonblur value="" placeholder="First Name*" id="first_name"
      maxlength="40" name="first_name" ngModel #firstname="ngModel">
  </div>

  <div class="form-group">
    <input type="text" class="form-control" required validateonblur value="" placeholder="Last Name*" id="last_name"
      maxlength="80" name="last_name" ngModel #lastname="ngModel">
  </div>
</div>
<div class="shortrow">
  <div class="form-group">
    <input class="form-control" type="number" min="10" formControlName="phone" [(ngModel)]="phone" required
      validateonblur value=""
      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
      (input)="inputValidator($event)" maxlength="10" placeholder="Phone Number*" id="phone" name="phone">
  </div>
  <div class="form-group">
    <input class="form-control" type="email" name="email" placeholder="Email Address*" ngModel
      #emailWithPattern="ngModel" pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$" maxlength="80" required>
  </div>
</div>
<div class="shortrow">
  <div class="form-group">
    <input type="text" class="form-control" required validateonblur value="" placeholder="Business Name*" id="company"
      maxlength="255" name="company" ngModel #company="ngModel">
  </div>
  <div class="form-group">
    <select class="form-control" required value="" id="00NWC000005qHEn" name="00NWC000005qHEn">
      <option value="" disabled selected>Fleet Size*</option>
      <option *ngFor="let fleetsize of fleetSizes" [value]="fleetsize">
        {{ fleetsize }}
      </option>
    </select>
  </div>
</div>
<div class="shortrow">
  <div class="form-group">
    <select class="form-control" name="state" required [(ngModel)]="selectedState" (change)="getCounties()"
      [disabled]="isStateDisabled" id="state" name="state">
      <option value="" disabled selected>State*</option>
      <option *ngFor="let state of states" [value]="state">
        {{ state }}
      </option>
    </select>
  </div>
  <div class="form-group">
    <select class="form-control" name="county" required [(ngModel)]="selectedCounty" [disabled]="isCountyDisabled"
      id="00N8W00000PYJyH" name="00N8W00000PYJyH">
      <option value="" disabled selected>County*</option>
      <option *ngFor="let county of counties" [value]="county">
        {{ county }}
      </option>
    </select>
  </div>
</div>


<!-- <label for="recordType">Lead Record Type</label> -->
<select id="recordType" name="recordType" hidden>
  <option value="">--None--</option>
  <option value="0124R0000014p1d" selected="selected">Insurance</option>
  <option value="0121I000000Jso2">DTNA Orderboard Leads</option>
  <option value="0121I000000JtAG">DTNA Program Lead</option>
  <option value="0128W000000epvI">Dynamic Insurance Lead</option>
  <option value="0121I000000JtAL">FMV</option>
  <option value="0121I000000Jso7">Other</option>
</select>

<!-- <label for="lead_source">Lead Source</label> -->
<select id="lead_source" name="lead_source" hidden>
  <option value="">--None--</option>
  <option value="Dealer">Dealer</option>
  <option value="HDVI">HDVI</option>
  <option value="DTNA_Orderboard">DTNA_Orderboard</option>
  <option value="Other">Other</option>
  <option value="Dynamic Lease">Dynamic Lease</option>
  <option value="DTNA Program">DTNA Program</option>
  <option value="DTNA/DTR FMV">DTNA/DTR FMV</option>
  <option value="Dynamic Insurance Lead">Dynamic Insurance Lead</option>
  <option value="Website - Dynamic Lease">Website - Dynamic Lease</option>
  <option value="Website - Connected Insurance" selected="selected">Website - Connected Insurance</option>
  <option value="Website - Dynamic Insurance">Website - Dynamic Insurance</option>
  <option value="Email">Email</option>
</select>

<select id="00N1I00000OUe8n" name="Lead_Type__c" hidden>
  <option value="Insurance" selected="selected">Insurance</option>
</select>

<select  id="DTFS_Language__c" name="DTFS_Language__c" hidden>
  <option value="EN" selected="selected">EN</option>
</select>

  <select id="Country_Code__c" name="Country_Code__c" hidden>
    <option value="US" selected="selected">US</option>
  </select>

<!-- <input type="hidden" class="form-check-input" required id="00N0q000005yvHz" name="00N0q000005yvHz" value="0">Dynamic Insurance Flag -->

<div class="form-check" style="padding-left: 0px;">
  <label class="checkboxlabel" for="checkbox" style="text-align: justify;">
    <p> By clicking submit, I agree that Daimler Truck Financial Services, Daimler Truck Insurance Agency, and GEICO may
      contact me with marketing communications related to Connected Insurance. I understand that my information will be used
      in accordance with the <a href="{{this.usUrl}}/home/useAndPrivacy">Daimler Truck Privacy Policy</a> and the <a
        href="https://www.geico.com/privacy/">GEICO Privacy Policy</a>.</p>
  </label>
</div>


<!--Error Display to Modal View-->
<div class="mbfs-cavd-error-block mbfs-white-content-box" *ngIf="this.serviceErrorOccurred">
  <h5 class="mbfs-modal-error">{{this.serviceErrorDesc}}<br></h5>
</div>
<div class="captcha" *ngIf="this.captchaToggle">
  <div id="capcha_element" class="g-recaptcha" data-theme="light"
    style="transform:scale(0.85);-webkit-transform:scale(0.85);transform-origin:0 0;-webkit-transform-origin:0 0; display:inline-block; text-align: center;padding-left: 10%;"
    data-callback="getResponceCapcha" data-expired-callback="recaptchaResponseExpired"
    data-error-callback="recaptchaError">
  </div>
</div>

<button type="submit" name="submit" class="mbfs-button">Submit</button>
<p style="float: right;" class="checkboxlabel"><span style="color: #00566A;">* </span>required</p> <br>
<br><br>
</form>
</div>
